import _slicedToArray from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _objectWithoutProperties from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _classCallCheck from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
var _excluded = ["speed"];

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import _extends from '@babel/runtime/helpers/esm/extends';
import * as React from 'react';
import { MeshStandardMaterial } from 'three';
import { useFrame } from '@react-three/fiber';

var WobbleMaterialImpl = /*#__PURE__*/function (_MeshStandardMaterial) {
  _inherits(WobbleMaterialImpl, _MeshStandardMaterial);

  var _super = _createSuper(WobbleMaterialImpl);

  function WobbleMaterialImpl() {
    var _this;

    var parameters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, WobbleMaterialImpl);

    _this = _super.call(this, parameters);

    _this.setValues(parameters);

    _this._time = {
      value: 0
    };
    _this._factor = {
      value: 1
    };
    return _this;
  }

  _createClass(WobbleMaterialImpl, [{
    key: "onBeforeCompile",
    value: function onBeforeCompile(shader) {
      shader.uniforms.time = this._time;
      shader.uniforms.factor = this._factor;
      shader.vertexShader = "\n      uniform float time;\n      uniform float factor;\n      ".concat(shader.vertexShader, "\n    ");
      shader.vertexShader = shader.vertexShader.replace('#include <begin_vertex>', "float theta = sin( time + position.y ) / 2.0 * factor;\n        float c = cos( theta );\n        float s = sin( theta );\n        mat3 m = mat3( c, 0, s, 0, 1, 0, -s, 0, c );\n        vec3 transformed = vec3( position ) * m;\n        vNormal = vNormal * m;");
    }
  }, {
    key: "time",
    get: function get() {
      return this._time.value;
    },
    set: function set(v) {
      this._time.value = v;
    }
  }, {
    key: "factor",
    get: function get() {
      return this._factor.value;
    },
    set: function set(v) {
      this._factor.value = v;
    }
  }]);

  return WobbleMaterialImpl;
}(MeshStandardMaterial);

var MeshWobbleMaterial = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _ref$speed = _ref.speed,
      speed = _ref$speed === void 0 ? 1 : _ref$speed,
      props = _objectWithoutProperties(_ref, _excluded);

  var _React$useState = React.useState(function () {
    return new WobbleMaterialImpl();
  }),
      _React$useState2 = _slicedToArray(_React$useState, 1),
      material = _React$useState2[0];

  useFrame(function (state) {
    return material && (material.time = state.clock.getElapsedTime() * speed);
  });
  return /*#__PURE__*/React.createElement("primitive", _extends({
    dispose: undefined,
    object: material,
    ref: ref,
    attach: "material"
  }, props));
});
export { MeshWobbleMaterial };